export default __webpack_public_path__ + "static/media/copy-white.66abca01.svg";